varying vec2 vUv; 
uniform float u_power;
uniform float u_LoaderProgress;

void main()
{
    vec2 ndc = (vUv -0.5)*2.;
    // ndc *=100.;
    // ndc = clamp(ndc, 0., 1.);

    vec3 finalCol = vec3(0.9137254901960784, 0.592156862745098, 0.5686274509803921);

    float alpha = abs(ndc.x)-u_LoaderProgress;

    alpha = clamp(alpha, 0., 1.);
    alpha = 1.-smoothstep(0., 0.05, alpha);


    gl_FragColor = vec4(finalCol*alpha*0.8, 1.);
    // gl_FragColor = vec4(vec3(alpha), 1.);
}